import styled from 'styled-components';
import {ListTitleTextDefaultBox} from './list-title-text.default.box';
import {JACKPOT_WIDGET, RED_TIGER_JACKPOT} from "../../constants";
import {HOME_PAGE} from '../../../../themes/css-global-classes';

export const ListTitleTextMrGreenBox = styled(ListTitleTextDefaultBox)`
    background: none;
    border-left: 0;

    /* This is done to keep the alignment between the list title and the first game in the list */
    padding-left: calc(max(0px, 100% / 7 - 21rem) / 2);
    .${HOME_PAGE} & {
        padding-left: calc(max(0px, 100% / 6 - 21rem) / 2);
    }
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        padding-left: 10px;
        .${HOME_PAGE} & {
            padding-left: 10px;
        }
    }

    font-size: 2.4rem;
    letter-spacing: normal;
    @media ${({theme}) => theme.mediaQuery.mAndBelow} {
        font-size: 1.6rem;
    }

    .${JACKPOT_WIDGET} & {
        border-left: 0;
    }

    .${RED_TIGER_JACKPOT} & {
        border-left: 0;
    }
`;

